export default {"src":"/_next/static/media/step3b.e725e87c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};